import { AdminApiClient, AuthenticatedApiClient, JwtAuthenticatedApiClient } from '@guiker/notification-shared'
import { useAuthenticatedApiClient, useJwtAuthenticatedApiClient } from '@guiker/react-framework'

export const useAuthenticatedNotificationApiClient = useAuthenticatedApiClient(AuthenticatedApiClient)
export const useAdminNotificationApiClient = useAuthenticatedApiClient(AdminApiClient)
export const useJwtAuthenticatedNotificationApiClient = useJwtAuthenticatedApiClient(JwtAuthenticatedApiClient)
